export default API => ({
    //获取推广中心列表
    findByCondition(data) {
        return API({
            url:`/order/v1/open/agentGoods/findByCondition?pageSize=${data.pageSize}&pageNum=${data.pageNum}&goodsName=${data.goodsName}`,
            method:'get',
            data
        });
    },

    //我的收益

    findIncomeInfo(data) {
        return API({
            url:`/order/v1/client/orderAgent/findIncomeInfo`,
            method:'post',
            data
        });
    },

    //月推广收益列表
    findMonthIncomeList(data) {
        return API({
            url:`/order/v1/client/orderAgent/findMonthIncomeList`,
            method:'post',
            data
        });
    },


    //月累计收益
    findTotalIncome(data) {
        return API({
            url:`/order/v1/client/orderAgent/findTotalIncome`,
            method:'post',
            data
        });
    },  
    

    //直接收益列表
    findDirectIncome(data) {
        return API({
            url:`/order/v1/client/orderAgent/findDirectIncome`,
            method:'post',
            data
        });
    },  

    
    
    //间接收益列表收益列表
    findIndirectIncome(data) {
        return API({
            url:`/order/v1/client/orderAgent/findIndirectIncome`,
            method:'post',
            data
        });
    },  


    
    //查看二维码
    getQrCode(data) {
        return API({
            url:`/order/v1/open/agentGoods/getQrCode?goodsId=${data.goodsId}`, //agentId=${data.agentId}&
            method:'get',
            data
        });
    }, 





})
